import { render, staticRenderFns } from "./BaseHeader.vue?vue&type=template&id=ecaf47c4"
import script from "./BaseHeader.vue?vue&type=script&lang=ts"
export * from "./BaseHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports